export const COE = 'client-onboarding';
export const HGT = 'heatmap-generation';